import React from "react";
import jbImage from '../assets/images/jb-main.png'
import netcoinsImage from '../assets/images/netcoins.png'
import gspImage from '../assets/images/gsp.png'
import wcImage from '../assets/images/wc-main.png'
import chikooImage from '../assets/images/chikoo.png'
import allsetraImage from '../assets/images/allsetra.png'
import '../assets/styles/Project.scss';

function Project() {
    return(
    <div className="projects-container" id="projects">
        <h1>Projects</h1>
        <div className="projects-grid">
            <div className="project">
                <a href="https://j-b.com.sa/en/" target="_blank" rel="noreferrer"><img src={jbImage} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://j-b.com.sa/en/" target="_blank" rel="noreferrer"><h2>JB by Saudi Fransi Bank</h2></a>
                <p>Developed and maintained the platform using React (Gatsby JS), Material UI, GraphQL, and Contentful as a headless CMS, focusing on performance, scalability, and clean component architecture.</p>
            </div>
            
            <div className="project">
                <a href="https://www.netcoins.com/" target="_blank" rel="noreferrer"><img src={netcoinsImage} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://www.netcoins.com/" target="_blank" rel="noreferrer"><h2>NetCoins</h2></a>
                <p>Built and optimized the NetCoins platform using Next.js and Storyblok CMS, implementing reusable UI components with Material UI, data visualizations with React Charts, and live content editing workflows.</p>
            </div>
            <div className="project">
                <a href="https://globalschoolpayments.com/" target="_blank" rel="noreferrer"><img src={gspImage} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://globalschoolpayments.com/" target="_blank" rel="noreferrer"><h2>Global School Payments</h2></a>
                <p>Developed a scalable frontend using React and Ant Design, implemented data-driven dashboards with Ant Charts, and integrated Firebase Functions to support secure and efficient serverless operations.</p>
            </div>
             <div className="project">
                <img src={wcImage} className="zoom" alt="thumbnail" width="100%"/>
                <h2>Wordcraft</h2>
                <p>Developed a Telegram-based game application using Next.js and Ant Design, and implemented Firebase Functions to handle serverless logic, game state, and real-time interactions.</p>
            </div>
            <div className="project">
                <a href="https://allsetra.com/" target="_blank" rel="noreferrer"><img src={allsetraImage} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://allsetra.com/" target="_blank" rel="noreferrer"><h2>Allsetra</h2></a>
                <p>Designed and implemented GPS tracking and analytical reports using multi-source data, built interactive visual dashboards, and improved application performance for large-scale fleet monitoring.</p>
            </div>
             <div className="project">
                <a href="https://chikoo.app/" target="_blank" rel="noreferrer"><img src={chikooImage} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://chikoo.app/" target="_blank" rel="noreferrer"><h2>Chikoo</h2></a>
                <p>Contributed to the project by Implementing key business features including Foodpanda and courier integrations, FBR-compliant invoicing via ChikooPOS, and draft order workflows, with a strong focus on performance and reliability.</p>
            </div>
        </div>
    </div>
    );
}

export default Project;